// removed by extract-text-webpack-plugin
module.exports = {"chart":"Charts_chart-item_chart---3GqzA"};